import React from "react";
import { ServiceSteps } from "../../types/serviceDetail";

interface Props {
  serviceSteps: ServiceSteps[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceStep: React.FC<Props> = ({
  serviceSteps,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const HeadingTag = isPage ? "h4" : "p";
  const SubHeadingTag = isPage ? "h5" : "p";
  let isCurrentPass = false; // Track if the current step has passed

  const getClass = (serviceId: number, otherServiceId: number | null) => {
    if (serviceId === otherServiceId) {
      isCurrentPass = true;
      return "current";
    }
    return isCurrentPass ? " upcoming" : "done";
  };

  return (
    <div className="container py-4">
      {sectionTitle && (
        <HeadingTag
          className="text-center font-16 text-black ff-semibold mb-4"
          dangerouslySetInnerHTML={{ __html: sectionTitle }}
        />
      )}

      {line && (
        <SubHeadingTag
          className="font-12 text-grey ff-normal text-center"
          dangerouslySetInnerHTML={{ __html: line }}
        />
      )}

      <div className="row justify-content-center">
        <div className="timeline-container">
          {serviceSteps.map((step, index) => (
            <div key={`steps_${index}`} className="timeline-card layout-border">
              <div className="timeline-step"></div>
              <div className="d-flex ">
                <div
                  className={`timeline-title ju ${getClass(
                    step.service_id,
                    step.step_service_id
                  )} font-12 ff-semibold mb-2`}
                >
                  <div>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 7 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.27045 1.00428C5.7922 1.30553 6.22623 1.73782 6.52956 2.25837C6.8329 2.77891 6.99502 3.36965 6.99989 3.9721C7.00475 4.57456 6.85219 5.16784 6.55731 5.69321C6.26242 6.21859 5.83543 6.65784 5.31862 6.96748C4.8018 7.27712 4.21308 7.44642 3.61073 7.45861C3.00837 7.4708 2.41328 7.32546 1.88436 7.03698C1.35544 6.74851 0.911032 6.32689 0.595129 5.81388C0.279227 5.30087 0.102786 4.71424 0.0832726 4.11209L0.081543 4.00001L0.0832726 3.88792C0.102646 3.29051 0.276489 2.7083 0.587856 2.19807C0.899222 1.68784 1.33748 1.26699 1.85992 0.976562C2.38235 0.686132 2.97112 0.536029 3.56884 0.540886C4.16655 0.545743 4.75281 0.705395 5.27045 1.00428ZM4.82317 3.06358C4.7636 3.00402 4.68435 2.96824 4.60028 2.96295C4.51621 2.95767 4.4331 2.98324 4.36654 3.03487L4.33402 3.06358L3.19489 4.20237L2.7476 3.75543L2.71509 3.72672C2.64852 3.67513 2.56543 3.64959 2.48138 3.65489C2.39733 3.66019 2.3181 3.69598 2.25855 3.75553C2.199 3.81507 2.16322 3.8943 2.15792 3.97835C2.15262 4.0624 2.17816 4.1455 2.22975 4.21206L2.25846 4.24458L2.95032 4.93643L2.98283 4.96514C3.0435 5.01221 3.1181 5.03776 3.19489 5.03776C3.27167 5.03776 3.34627 5.01221 3.40694 4.96514L3.43946 4.93643L4.82317 3.55272L4.85188 3.5202C4.90351 3.45365 4.92908 3.37054 4.92379 3.28647C4.91851 3.2024 4.88273 3.12315 4.82317 3.06358Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="font-10 ff-bold flex-grow-1">
                    {step.service_id === step.step_service_id
                      ? `Current Step ${index + 1}`
                      : `Step ${index + 1}`}
                  </div>
                </div>
              </div>

              <HeadingTag
                className="font-14 ff-bold text-black mb-1"
                dangerouslySetInnerHTML={{ __html: step.title ?? "" }}
              />
              <p
                className="font-12 ff-medium text-grey mb-1"
                dangerouslySetInnerHTML={{ __html: step.description ?? "" }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceStep;
